<mat-toolbar class="toolbar">
    <mat-toolbar-row>
        <button mat-icon-button (click)="toogleSideBar()">
            <mat-icon>menu</mat-icon>
        </button>

        <span> SWIGGY CLONE </span>

        <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
            <ul fxLayout="row" fxLayoutGap="20px">
              
               
                <li>
                    <button mat-button [matMenuTriggerFor]="menu">
                        <div class="circleBase type1">
                            <span class="text">{{user.name.charAt(0)}}</span>
                        </div>
                    </button>
                    <mat-menu #menu="matMenu">
                    <div class="dw-user-box">
                        <div id="container">
                            <div id="name">
                                {{user.name.charAt(0)}}
                             </div>
                         </div>
                      <h4 class="uname">{{user.name}}</h4>
                      <p class="email1">{{user.email}}</p>
                    </div>
                    <li class="divider" role="separator" style="list-style: none;">
                        <mat-divider></mat-divider>
                        <!-- routerLink="/dashboard/Profile" -->
                        <a (click)="profile()" class="list1">
                            <i class="material-icons icon1"> person</i>
                    <span class="spn">     My Profile</span>
                        </a>
<mat-divider></mat-divider>
                        <a (click)="change()" class="list1">
                            <i class="material-icons icon1"> lock</i>
                    <span class="spn">Change Password</span>
                        </a>
                        <mat-divider></mat-divider>
                        <a (click)="logOut()" class="list1">
                            <i class="material-icons icon1"> power_settings_new</i>
                    <span class="spn">Logout</span>
                        </a>
                    </li>
                    <!-- <button (click)="sign()"  mat-menu-item>
                            <mat-icon>exit_to_app</mat-icon>
                            Sign out
                        </button> -->
                    </mat-menu>

                </li>
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>